import { render, staticRenderFns } from "./legendBari.vue?vue&type=template&id=4cb93e88"
import script from "./legendBari.vue?vue&type=script&lang=js"
export * from "./legendBari.vue?vue&type=script&lang=js"
import style0 from "./legendBari.vue?vue&type=style&index=0&id=4cb93e88&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports